module.exports = __webpack_public_path__ + "img/dog.14352826.svg";